import React from 'react'

import FirstSection from './FirstSection'
import SecondSection from './SecondSection'

function MainSection() {

  return (
    <div className="min-h-screen">
      {/* First Section */}
        <FirstSection />
      
      {/* Second Section */}
       <div className='bg-white'>
       <SecondSection />
      </div>
    </div>
  )
}

export default MainSection